import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SplashCursor from './SplashCursor';
import { FaWhatsapp, FaTelegramPlane, FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa';
import './Terms.css'; // Reusing the premium styles
import './MainPage.css'; 
import Footer from './Footer';

const Disclosure = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="terms-page">
      <SplashCursor RAINBOW_MODE={false} COLOR="#A855F7" />

      {/* Navigation */}
      <header className="header">
        <div className="header-container">
          <div className="logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <img src="/images/Final Font Stocks4U1.png" alt="Stocks4U Logo" className="logo-text" style={{ width: '150px', height: 'auto' }} />
          </div>
          
          <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            <a href="/" onClick={() => setIsMobileMenuOpen(false)}>Home</a>
            <a href="/#features" onClick={() => setIsMobileMenuOpen(false)}>Features</a>
            <a href="/#pricing" onClick={() => setIsMobileMenuOpen(false)}>Pricing</a>
            <a href="/about" onClick={() => setIsMobileMenuOpen(false)}>About</a>
            <a href="/#contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</a>
          </nav>

          <button
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          
          <div className="header-buttons">
            <button className="login-btn" onClick={() => navigate('/login')}>Login</button>
            <button className="get-started-btn" onClick={() => navigate('/login')}>Get Started</button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="terms-hero-new">
        <div className="terms-hero-bg-glow"></div>
        <div className="terms-hero-content">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="terms-title-hero"
          >
            <span className="gradient-text-hero">Disclosure</span>
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="terms-hero-desc"
          >
            Disclosures, Risk Disclaimer & Terms of Use.
          </motion.p>
        </div>
      </section>

      {/* Content Section */}
      <section className="terms-content-section">
        <div className="container terms-container">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="terms-glass-card"
          >
            <div className="terms-header-info">
              <p><strong>Effective Date:</strong> <span className="highlight">[Effective Date]</span></p>
              <p><strong>Website/App Name:</strong> Stocks4U</p>
              <p><strong>Owned & Operated By:</strong> <span className="highlight">[Your Company Name]</span></p>
              <p><strong>Contact Email:</strong> <span className="highlight">[Your Email]</span></p>
              <p><strong>Registered Address:</strong> <span className="highlight">[Your Address]</span></p>
            </div>

            <p className="terms-intro">
              This document contains important disclosures, risk disclaimers, third-party data dependency disclosures, and terms of use applicable to Stocks4U.
              <br/><br/>
              By accessing or using Stocks4U, including our website, dashboard, tools, screeners, filters, alerts, charts, data views, APIs, software, and related services, you acknowledge that you have read, understood, and agreed to the disclosures and terms mentioned below.
            </p>

            <div className="terms-body">
              <section className="terms-point">
                <h2>1. DISCLOSURES OF ALL MATERIAL INFORMATION</h2>
                <p>Stocks4U is a technology-based stock market data filtering and analysis platform.</p>
                <p>Stocks4U helps users view, organize, filter, scan, and analyze market-related data through dashboards, screeners, technical tools, charts, alerts, filters, watchlists, and system-generated outputs.</p>
                <p>Stocks4U is not a stock broker, investment adviser, research analyst, portfolio manager, exchange, depository participant, mutual fund distributor, or any other regulated securities market intermediary.</p>
                <p>Stocks4U is a third-party API/data-dependent technology platform. Our services may depend on third-party APIs, market data vendors, brokers, exchanges, public sources, cloud service providers, payment gateways, analytics providers, and other external systems.</p>
                <p>Stocks4U does not provide personalized investment advice, trading advice, financial advice, buy/sell/hold recommendations, portfolio advice, research reports, wealth management services, or guaranteed profit strategies.</p>
              </section>

              <section className="terms-point">
                <h2>2. DISCIPLINARY HISTORY</h2>
                <p>As on the Effective Date mentioned above, there has been no instance of any disciplinary action, penalty, suspension, debarment, or regulatory action levied or passed against Stocks4U, its owners, partners, directors, or key representatives by any regulatory, administrative, or government authority, unless specifically disclosed separately in writing.</p>
                <p>If any such event occurs in the future, Stocks4U may update this disclosure as required.</p>
              </section>

              <section className="terms-point">
                <h2>3. NATURE OF SERVICES</h2>
                <p>Stocks4U provides technology tools for market data filtering, analysis support, and educational/informational usage.</p>
                <p>The platform may provide features such as:</p>
                <ul>
                  <li>Stock screeners</li>
                  <li>F&O stock filters</li>
                  <li>Market scanners</li>
                  <li>Technical indicator-based filters</li>
                  <li>Charts and dashboards</li>
                  <li>Watchlists</li>
                  <li>Alerts and notifications</li>
                  <li>Sector and stock analysis tools</li>
                  <li>Data visualization tools</li>
                  <li>Third-party API-based data display</li>
                </ul>
                <p>All outputs generated by Stocks4U are based on data processing, user-selected conditions, formulas, technical parameters, or system-based logic.</p>
                <p>Such outputs should not be treated as investment advice, research recommendation, trading call, or a guarantee of future performance.</p>
              </section>

              <section className="terms-point">
                <h2>4. NO INVESTMENT ADVISORY OR RESEARCH ANALYST SERVICE</h2>
                <p>Stocks4U, its owners, directors, employees, developers, partners, affiliates, representatives, and associates are not registered with SEBI as an Investment Adviser, Research Analyst, Stock Broker, Portfolio Manager, or any other regulated securities market intermediary, unless specifically stated in writing.</p>
                <p>Stocks4U does not issue research reports.</p>
                <p>Stocks4U does not provide stock recommendations.</p>
                <p>Stocks4U does not provide buy, sell, or hold calls.</p>
                <p>Stocks4U does not provide personalized financial planning.</p>
                <p>Stocks4U does not provide portfolio management.</p>
                <p>Stocks4U does not provide guaranteed trading strategies.</p>
                <p>Any data, alert, signal, score, filter, scanner, chart, watchlist, or output shown on Stocks4U is only for educational, informational, analytical, and technology-support purposes.</p>
                <p>Users should consult a SEBI-registered investment adviser, research analyst, financial advisor, or qualified professional before making any trading or investment decision.</p>
              </section>

              <section className="terms-point">
                <h2>5. THIRD-PARTY API AND DATA DEPENDENCY DISCLOSURE</h2>
                <p>Stocks4U may receive, process, calculate, display, or organize market-related data from third-party APIs, data providers, brokers, exchanges, vendors, public sources, or external systems.</p>
                <p>Stocks4U does not own, control, or guarantee the accuracy, availability, completeness, legality, reliability, speed, continuity, or real-time nature of such third-party data or APIs.</p>
                <p>Data displayed on Stocks4U may be:</p>
                <ul>
                  <li>Delayed</li>
                  <li>Incomplete</li>
                  <li>Incorrect</li>
                  <li>Unavailable</li>
                  <li>Mismatched</li>
                  <li>Interrupted</li>
                  <li>Affected by API failure</li>
                  <li>Affected by vendor-side errors</li>
                  <li>Affected by broker-side issues</li>
                  <li>Affected by exchange-side issues</li>
                  <li>Affected by software bugs or server downtime</li>
                </ul>
                <p>Stocks4U shall not be responsible for any loss, damage, wrong decision, trading loss, missed opportunity, financial loss, or business loss caused due to third-party API failure, incorrect data, delayed data, missing data, technical failure, calculation error, or any external service dependency.</p>
                <p>Users must verify all market data independently from their broker terminal, official exchange source, or other reliable source before making any trading or investment decision.</p>
              </section>

              <section className="terms-point">
                <h2>6. TERMS & CONDITIONS OF PLATFORM OUTPUTS</h2>
                <p>Stocks4U does not issue research reports or advisory reports.</p>
                <p>Any information, dashboard, alert, stock filter, screener result, chart, signal, score, data table, or market view displayed on Stocks4U is generated through technology, data processing, formulas, or predefined conditions.</p>
                <p>The information available on Stocks4U is believed to be based on sources considered reliable; however, Stocks4U does not guarantee its accuracy, completeness, reliability, or suitability for any particular user.</p>
                <p>Stocks4U does not make any representation that the information displayed is free from errors, omissions, delays, inaccuracies, or technical issues.</p>
                <p>The information displayed on Stocks4U does not constitute an offer, solicitation, invitation, recommendation, or advice to buy, sell, hold, subscribe, or trade in any security, derivative, commodity, currency, or financial instrument.</p>
              </section>

              <section className="terms-point">
                <h2>7. RISK DISCLOSURES</h2>
                <p>Trading and investing in securities markets involve significant risk.</p>
                <p>Users may lose part or all of their invested capital.</p>
                <p>F&O trading, options trading, intraday trading, margin trading, and leverage-based trading involve high risk and may not be suitable for all users.</p>
                <p>Market movement is uncertain and can be affected by volatility, liquidity, news, global events, economic conditions, corporate events, regulatory changes, technical factors, and unexpected risks.</p>
                <p>Stocks4U, its owners, directors, employees, developers, partners, affiliates, and representatives shall not be responsible for any loss or damage arising from the use of any information, data, alert, scanner, screener, filter, chart, or tool available on the platform.</p>
                <p>Users should understand their own risk appetite, financial position, investment objective, trading experience, and capital capacity before making any market-related decision.</p>
              </section>

              <section className="terms-point">
                <h2>8. USER-SPECIFIC OBJECTIVES NOT CONSIDERED</h2>
                <p>Stocks4U does not consider any user’s personal financial situation, investment objective, income level, risk appetite, trading experience, portfolio size, age, liabilities, or financial goals.</p>
                <p>Any output shown on Stocks4U is general in nature and not customized for any specific individual.</p>
                <p>Users should make decisions according to their own risk profile and financial condition.</p>
                <p>Stocks4U does not accept responsibility for any decision taken by users based on platform data or outputs.</p>
              </section>

              <section className="terms-point">
                <h2>9. DISCLOSURES WITH REGARD TO OWNERSHIP AND MATERIAL CONFLICTS OF INTEREST</h2>
                <p>Stocks4U or its owners, partners, directors, employees, developers, associates, or relatives may or may not hold securities, derivatives, or positions in companies, sectors, or instruments displayed on the platform.</p>
                <p>Since Stocks4U is a technology platform and does not issue research recommendations, users should not interpret any stock, index, symbol, sector, alert, or data point shown on the platform as a recommendation influenced by ownership or conflict of interest.</p>
                <p>Stocks4U does not intentionally display any stock or market data for the purpose of manipulating, influencing, or inducing users to buy, sell, or hold any security.</p>
                <p>Wherever applicable, Stocks4U may disclose any material conflict of interest if required by law or internal policy.</p>
              </section>

              <section className="terms-point">
                <h2>10. DISCLOSURES WITH REGARD TO RECEIPT OF COMPENSATION</h2>
                <p>Stocks4U may earn revenue through subscriptions, software access fees, advertisements, affiliate partnerships, data services, technology services, or other commercial arrangements.</p>
                <p>Unless specifically disclosed, Stocks4U does not receive compensation from any listed company for displaying its stock symbol, data, chart, or information on the platform.</p>
                <p>Unless specifically disclosed, Stocks4U does not receive compensation from any subject company in connection with any platform output, screener result, alert, or data view.</p>
                <p>Stocks4U does not manage or co-manage public offerings of securities.</p>
                <p>Stocks4U does not provide paid promotional research recommendations on securities unless clearly disclosed in writing.</p>
              </section>

              <section className="terms-point">
                <h2>11. SUBSCRIPTION TERMS</h2>
                <p>Stocks4U services may be available through free or paid subscription plans.</p>
                <p>The validity of paid services will be based on the selected subscription plan from the date of successful payment.</p>
                <p>Subscription features, pricing, duration, access limits, and benefits may vary depending on the selected plan.</p>
                <p>Stocks4U may modify, suspend, or discontinue any plan, feature, data source, tool, or service at any time.</p>
                <p>Fees paid towards Stocks4U services are generally non-refundable unless specifically mentioned in a separate refund policy or required by applicable law.</p>
                <p>No refund shall be provided for trading losses, market losses, dissatisfaction with trading results, non-usage of the platform, misunderstanding of features, third-party API failure, data delay, or external service disruption.</p>
              </section>

              <section className="terms-point">
                <h2>12. ALERTS AND NOTIFICATIONS</h2>
                <p>Stocks4U may provide alerts, notifications, filters, scanners, signals, or watchlist updates based on predefined conditions, technical indicators, market data, or user-selected criteria.</p>
                <p>These alerts are system-generated outputs and are not personal advice or recommendations.</p>
                <p>Stocks4U does not guarantee that alerts will be accurate, timely, profitable, uninterrupted, or suitable for any user.</p>
                <p>Users should not buy, sell, hold, enter, exit, or trade solely based on alerts, signals, or notifications received from Stocks4U.</p>
              </section>

              <section className="terms-point">
                <h2>13. NO BROKERAGE OR ORDER EXECUTION</h2>
                <p>Stocks4U does not execute trades, place orders, hold user funds, manage securities, provide margin, open demat accounts, or act as a broker.</p>
                <p>If Stocks4U integrates with any broker API, trading API, or third-party execution service in the future, such integration will only act as a technology interface and will remain subject to applicable laws, broker terms, API provider terms, user authorization, and third-party policies.</p>
                <p>Stocks4U shall not be responsible for failed orders, delayed orders, rejected orders, slippage, wrong order placement, broker downtime, exchange downtime, API errors, technical failure, or losses caused by third-party trading systems.</p>
              </section>

              <section className="terms-point">
                <h2>14. MARKET RISK</h2>
                <p>Market conditions can change rapidly due to economic events, news, interest rates, inflation, global markets, government policies, liquidity, volatility, corporate announcements, and other factors.</p>
                <p>Adverse changes in market conditions may negatively affect stock prices, derivative prices, liquidity, and trading outcomes.</p>
                <p>Users are fully responsible for understanding market risk before making any trading or investment decision.</p>
              </section>

              <section className="terms-point">
                <h2>15. FINANCIAL RISK</h2>
                <p>Trading and investing may lead to financial loss.</p>
                <p>Users may lose part or all of their invested capital.</p>
                <p>Leverage, margin, options, futures, and intraday trading may increase both profit potential and loss potential.</p>
                <p>Stocks4U does not guarantee capital protection, fixed returns, profits, or any financial benefit.</p>
              </section>

              <section className="terms-point">
                <h2>16. OPERATIONAL RISK</h2>
                <p>Stocks4U may face operational risks such as server downtime, API failure, software bugs, calculation errors, data vendor issues, cyber incidents, cloud service issues, internet failure, maintenance downtime, or system interruptions.</p>
                <p>Such operational issues may affect platform availability, data display, alerts, dashboards, or user experience.</p>
                <p>Stocks4U shall not be liable for any loss caused due to operational disruptions.</p>
              </section>

              <section className="terms-point">
                <h2>17. REGULATORY RISK</h2>
                <p>The securities market is subject to laws, regulations, exchange rules, SEBI circulars, broker policies, data vendor policies, and government guidelines.</p>
                <p>Any change in law, regulation, exchange policy, data usage rule, API policy, or broker restriction may affect Stocks4U’s features, data availability, pricing, access, or services.</p>
                <p>Stocks4U may modify, limit, suspend, or discontinue features to comply with legal, regulatory, exchange, vendor, or API-related requirements.</p>
              </section>

              <section className="terms-point">
                <h2>18. TECHNOLOGY RISK</h2>
                <p>Stocks4U relies on technology infrastructure, software systems, APIs, internet connectivity, servers, databases, cloud services, and external integrations.</p>
                <p>Any technical failure, cyberattack, unauthorized access, malware, data breach, service outage, or system error may affect platform performance or data availability.</p>
                <p>Users understand and accept the technology-related risks associated with using an online market data platform.</p>
              </section>

              <section className="terms-point">
                <h2>19. DATA RISK</h2>
                <p>Market data may be delayed, inaccurate, incomplete, or unavailable.</p>
                <p>Different brokers, exchanges, vendors, and APIs may show different prices, volumes, open interest, charts, or other market data.</p>
                <p>Stocks4U does not guarantee that the data displayed on the platform will match any broker terminal, exchange terminal, or third-party platform.</p>
                <p>Users must independently verify data before taking action.</p>
              </section>

              <section className="terms-point">
                <h2>20. COMPETITION RISK</h2>
                <p>Stocks4U operates in a technology and financial data-related industry where competition, innovation, pricing changes, user expectations, and third-party dependency may affect platform development and service delivery.</p>
                <p>Stocks4U may update or change its features based on business, technology, market, or compliance requirements.</p>
              </section>

              <section className="terms-point">
                <h2>21. CYBERSECURITY RISK</h2>
                <p>Stocks4U may be exposed to cybersecurity risks such as hacking, phishing, malware, unauthorized access, data theft, denial-of-service attacks, or other cyber threats.</p>
                <p>Stocks4U will take reasonable steps to protect the platform, but no online system can be guaranteed to be fully secure.</p>
                <p>Users are responsible for maintaining the confidentiality of their login credentials and account access.</p>
              </section>

              <section className="terms-point">
                <h2>22. DATA LICENSING AND USAGE</h2>
                <p>Market data may be subject to exchange rules, data vendor terms, API provider terms, broker terms, licensing restrictions, and applicable laws.</p>
                <p>Stocks4U does not grant users any ownership rights over market data, exchange data, third-party data, API data, or vendor-provided data.</p>
                <p>Users are not allowed to copy, scrape, download, redistribute, resell, republish, commercially exploit, or misuse any data available on Stocks4U without written permission and required third-party approvals.</p>
                <p>If any exchange, data provider, broker, API provider, or authority restricts, modifies, or stops data access, Stocks4U may change, suspend, limit, or remove related features without prior notice.</p>
              </section>

              <section className="terms-point">
                <h2>23. NO OFFICIAL AFFILIATION</h2>
                <p>Unless specifically stated in writing, Stocks4U is not officially affiliated with SEBI, NSE, BSE, MCX, NSDL, CDSL, any stock broker, exchange, index provider, data vendor, regulator, or listed company.</p>
                <p>All third-party names, stock symbols, company names, exchange names, logos, trademarks, and references belong to their respective owners.</p>
                <p>Any reference to stocks, indices, brokers, exchanges, or third-party services is made only for identification, integration, display, or informational purposes.</p>
              </section>

              <section className="terms-point">
                <h2>24. USER RESPONSIBILITY</h2>
                <p>By using Stocks4U, the user confirms that:</p>
                <ul>
                  <li>The user understands the risks of trading and investing.</li>
                  <li>The user is using Stocks4U only as a technology and analysis-support tool.</li>
                  <li>The user will not treat any data, alert, filter, scanner, chart, score, or output as guaranteed advice.</li>
                  <li>The user will verify all data independently before making decisions.</li>
                  <li>The user will make all trading and investment decisions at their own risk.</li>
                  <li>The user will not hold Stocks4U responsible for any trading loss, investment loss, missed opportunity, or financial outcome.</li>
                  <li>The user will comply with applicable laws, exchange rules, broker terms, API terms, data provider terms, and platform policies.</li>
                </ul>
              </section>

              <section className="terms-point">
                <h2>25. LIMITATION OF LIABILITY</h2>
                <p>To the maximum extent permitted by law, Stocks4U, its owners, directors, employees, developers, partners, affiliates, representatives, and associates shall not be liable for any direct, indirect, incidental, special, consequential, financial, business, trading, investment, opportunity, or data-related loss arising from:</p>
                <ul>
                  <li>Use of the platform</li>
                  <li>Inability to use the platform</li>
                  <li>Incorrect data</li>
                  <li>Delayed data</li>
                  <li>Missing data</li>
                  <li>API failure</li>
                  <li>Third-party service issue</li>
                  <li>Wrong alerts or signals</li>
                  <li>Software bug</li>
                  <li>Calculation error</li>
                  <li>Technical downtime</li>
                  <li>Market volatility</li>
                  <li>Trading or investment decision</li>
                  <li>Broker or exchange issue</li>
                  <li>User misunderstanding</li>
                  <li>Unauthorized account access</li>
                  <li>Regulatory changes</li>
                  <li>Data vendor restrictions</li>
                </ul>
                <p>Your use of Stocks4U is entirely at your own risk.</p>
              </section>

              <section className="terms-point">
                <h2>26. FINAL DISCLAIMER</h2>
                <p>Stocks4U is a third-party API/data-dependent technology platform for stock market data filtering, analysis support, and educational/informational use.</p>
                <p>Stocks4U is not an investment adviser, research analyst, stock broker, portfolio manager, exchange, or official market data provider unless specifically stated in writing.</p>
                <p>Stocks4U does not provide tips, calls, recommendations, guaranteed profits, portfolio advice, personalized financial guidance, or research reports.</p>
                <p>All users are fully responsible for their own research, decisions, trades, investments, capital allocation, risk management, and financial outcomes.</p>
                <p><strong>By using Stocks4U, you confirm that you have read, understood, and accepted this Disclosure, Risk Disclaimer & Terms of Use.</strong></p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Disclosure;
